<!--计件工资单价-->
<template>
  <ls-table-layout>
    <template #search>
      <ls-button-group
        ref="statesTabsRef"
        :current="activeTableKey"
        :button-item="PIECEWORK_WAGE_TABLE_LIST"
        type="tabs"
        @select="onChangeState"
        style="margin-bottom: 8px"
      >
      </ls-button-group>
      <SearchForm ref="searchFormRef" @search="onSearch" :tableKey="activeTableKey" />
    </template>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button
        v-if="activeTableKey === PIECEWORK_WAGE_TABLE.day.id"
        @click="onRefreshWage"
        type="primary"
        :disabled="btnLoading"
        v-hasPermi="['fun_1932774175240638465_EiXKh']"
      >
        刷新日工资
      </a-button>
      <a-button v-hasPermi="['fun_1932774175240638465_vrCSx']" :loading="exportLoading" @click="handleExport">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="baseTable"
          :columns="columns"
          :table-props="tableProps"
          :scroll="{ x: scrollX, fixScreen: true }"
          :custom-selection="{ stickyFixed: true }"
        >
          <!--确认日工资-->
          <template #confirmSalary="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.confirmSalaryErrIs }"
              v-if="record.editIs"
              v-model="record.confirmSalary"
            />
            <template v-else>{{ record.confirmSalary }}</template>
          </template>
          <template #monthFormat="{ text }">
            {{ formatTime(text, 'YYYY-MM') }}
          </template>
          <template #textEllipsis="{ text }">
            <a-tooltip class="text-3-ellipsis" :title="text" placement="topLeft">{{ text }}</a-tooltip>
          </template>
          <template #remark="{ record }">
            <a-input v-if="record.editIs" v-model="record.remark" :maxLength="200" />
            <a-tooltip v-else class="text-3-ellipsis" :title="record.remark" placement="topLeft">{{ record.remark }}</a-tooltip>
          </template>
          <template #operation="{ record }">
            <div v-hasPermi="['fun_1932774175240638465_rqFPQ']">
              <a-button
                v-if="!record.editIs"
                type="link"
                class="link-btn"
                @click="() => onEdit(record, 1)"
              >编辑</a-button>
              <template v-else>
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onSave(record)"
                >保存</a-button>
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onEdit(record, 0)"
                >取消</a-button>
              </template>
              <a-button type="link" class="link-btn" @click="handleLog(record)">日志</a-button>
            </div>
          </template>
          <template #operationMonth="{ record }">
            <a-button
              v-hasPermi="['bom:bomSalaryUnitPriceCc:edit']"
              type="link"
              class="link-btn"
              @click="() => onShowMonthDetail(record)"
            >查看明细</a-button>
          </template>
        </ls-api-table>
      </div>
      <download-modal :apiFun="exportApiFunc" ref="download" />
      <OperationLogModel ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      <UpdateDayWage ref="updateDayWageRef" @successCall="refreshList" :mainBtnLoading="btnLoading" />
      <MonthWageDetailModal ref="monthWageDetailModalRef" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData, transferEnumToMap } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import SearchForm from './components/search-form.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import { DAY_COLS, MONTH_COLS, PIECEWORK_WAGE_TABLE, STATUS_CODE } from './common'
import deepClone from 'lodash/cloneDeep'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import MonthWageDetailModal from './components/month-wage-detail-modal.vue';
import {
  apiDailySalaryList,
  apiExportDailySalaryList, apiExportMonthSalaryList,
  apiMonthSalaryList, apiUpdateDailySalary
} from '@/api/mes/productionPrepare/ccPieceworkWage'
import UpdateDayWage from '@/views/mes/productionPrepare/calcPieceworkWage/components/update-day-wage.vue'
import { getMesDiscreteJobsCcLogApi } from '@/api/mes/workOrderManage/ticketsManageCc'
export default {
  name: 'CalcPieceworkWage',
  components: {
    OperationLogModel,
    DownloadModal,
    SearchForm,
    ImportExcel,
    UpdateDayWage,
    MonthWageDetailModal
  },
  data() {
    this.DAY_COLS = JSON.parse(JSON.stringify(DAY_COLS));
    this.MONTH_COLS = JSON.parse(JSON.stringify(MONTH_COLS));
    this.statusNameMap = transferEnumToMap(STATUS_CODE)
    return {
      activeTableKey: PIECEWORK_WAGE_TABLE.day.id,
      logList: [],
      logLoading: false,
      btnLoading: false,
      exportLoading: false
    }
  },
  computed: {
    scrollX() {
      return {
        [PIECEWORK_WAGE_TABLE.day.id]: 2800,
        [PIECEWORK_WAGE_TABLE.month.id]: 1100
      }[this.activeTableKey]
    },
    PIECEWORK_WAGE_TABLE_LIST() {
      return Object.values(PIECEWORK_WAGE_TABLE);
    },
    PIECEWORK_WAGE_TABLE() {
      return PIECEWORK_WAGE_TABLE
    },
    columns() {
      return {
        [PIECEWORK_WAGE_TABLE.day.id]: this.DAY_COLS,
        [PIECEWORK_WAGE_TABLE.month.id]: this.MONTH_COLS
      }[this.activeTableKey]
    },
    tableProps() {
      const requestApi = {
        [PIECEWORK_WAGE_TABLE.day.id]: generateLsTableResData(apiDailySalaryList),
        [PIECEWORK_WAGE_TABLE.month.id]: generateLsTableResData(apiMonthSalaryList)
      }[this.activeTableKey]
      return {
        requestApi
      }
    },
    exportApiFunc() {
      return {
        [PIECEWORK_WAGE_TABLE.day.id]: apiExportDailySalaryList,
        [PIECEWORK_WAGE_TABLE.month.id]: apiExportMonthSalaryList
      }[this.activeTableKey]
    }
  },
  mounted() {
    this.refreshList();
  },
  methods: {
    onChangeState(list) {
      this.activeTableKey = list[0].id;
      this.refreshList();
    },
    onSave(record) {
      const { id, confirmSalary, remark } = record;
      const params = {
        id, confirmSalary, remark
      }
      if(!confirmSalary && confirmSalary !== 0) {
        return this.$message.error('日工资不能为空');
      }
      this.$set(record, 'loading', true);
      apiUpdateDailySalary(params).then(response => {
        if (response.code === 200) {
          this.$message.success('修改成功')
          this.refreshList(true);
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.$set(record, 'loading', false);
      })
    },
    onEdit(record, editStatus) {
      if(editStatus) {
        record.tempRow = deepClone(record);
      }else {
        const tempRow = record.tempRow;
        for (const item in record) {
          record[item] = tempRow[item];
        }
        delete record.tempRow;
      }
      this.$set(record, 'editIs', editStatus);
    },
    onShowMonthDetail(record) {
      this.$refs.monthWageDetailModalRef.show(record)
    },
    // 新建
    onRefreshWage() {
      this.$refs.updateDayWageRef.show()
    },
    onSearch(params) {
      if(!params.organizationCode) {
        return this.$message.error('加工组织');
      }
      this.$refs.baseTable.searchParams = params
      this.$refs.baseTable.getData(this.currentPageIs)
      this.currentPageIs = false
    },
    refreshList(currentPageIs) {
      this.currentPageIs = !!currentPageIs
      this.$refs.searchFormRef.handleFormSearch()
    },
    /** 导出按钮操作 */
    handleExport() {
      const params = this.$refs.baseTable.searchParams;
      this.$refs.download.openModal(params)
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show();
      getMesDiscreteJobsCcLogApi({ id: row.id, type: 22 }).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    formatTime(text, formatStr = 'YYYY-MM-DD HH:mm:ss') {
      if (text) {
        return this.$moment(text).format(formatStr)
      }
      return ''
    }
  }
}
</script>

<style scoped lang="less">
.link-btn {
  padding: 0 4px;
}
.text-3-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
/deep/.ant-input-number {
  width: 100%;
}
.select-width-130 {
  /deep/.ant-select {
    width: 120px;
  }
}
.error-border {
  border-color: #ff0000;
  /deep/.ant-select-selection {
    border-color: #ff0000;
  }
}
.error-text {
  font-size: 11px;
  color: #ff0000;
}
</style>
